import { IdToken } from "@auth0/auth0-react"
import React, { ReactNode, createContext, useEffect, useState } from "react"
import {
    CurrentGPSCoordinates,
    EFunctionalityOverrides,
    ENativeLayerIncomingEventType,
    NativeLayerIncomingEvent,
} from "../utils/nativeLayerCommunication/interfaces"

interface INativeWrapperProviderProps {
    children: ReactNode
}

export interface INativeLayerContext {
    auth0IdToken: IdToken | null
    nativeFunctionalityOverrides: EFunctionalityOverrides[] | null
    latestGPS: CurrentGPSCoordinates | null
}

const NativeLayerContext = createContext<INativeLayerContext>({} as INativeLayerContext)

export function NativeLayerProvider({ children }: INativeWrapperProviderProps) {
    const [latestGPS, setLatestGPS] = useState<CurrentGPSCoordinates | null>(null)
    const [auth0IdToken, setAuth0IdToken] = useState<IdToken | null>(null)
    const [nativeFunctionalityOverrides, setNativeFunctionalityOverrides] = useState<EFunctionalityOverrides[] | null>(
        null
    )

    useEffect(() => {
        // Listen for window.dispatchEvent("message") events from the native layer
        const messageListener = document.addEventListener("nativeEvent", (rawNativeEvent) => {
            const nativeEvent = (rawNativeEvent as CustomEvent).detail as NativeLayerIncomingEvent
            switch (nativeEvent.type) {
                case ENativeLayerIncomingEventType.SET_ID_TOKEN:
                    if (nativeEvent.auth0IdToken !== context.auth0IdToken) {
                        setAuth0IdToken(nativeEvent.auth0IdToken)
                    }
                    break
                case ENativeLayerIncomingEventType.SET_GPS:
                    setLatestGPS(nativeEvent.currentGPSCoordinates)
                    break
                case ENativeLayerIncomingEventType.SET_FUNCTIONALITY_OVERRIDES:
                    setNativeFunctionalityOverrides(nativeEvent.nativeFunctionalityOverrides)
                    break
                default:
                    console.error("Unknown native event:", rawNativeEvent)
                    break
            }
        })
        return messageListener
    }, [])

    const context = {
        auth0IdToken,
        latestGPS,
        nativeFunctionalityOverrides,
    }

    return <NativeLayerContext.Provider value={context}>{children}</NativeLayerContext.Provider>
}

export default NativeLayerContext
